/* @flow weak */
import cx from 'classnames';
import * as React from 'react';
import ReactDOM from 'react-dom';
import Link from 'components/Link.jsx';
import Glyph from 'components/Glyph.jsx';
import Image from 'components/Image.jsx';
import Button from 'components/Button.jsx';
import Buttons from 'components/Buttons.jsx';
import Dialog from 'components/Dialog.jsx';
import MediaObject from 'components/MediaObject.jsx';
import TextWithGlyph from 'components/TextWithGlyph.jsx';

import './styles/ImageFilePreviewModal.scss';

type Props = {
  file: FileGQL,
  className?: ?string,
  onRequestHide?: ?Function,
};

class ImageFilePreviewModal extends React.Component<Props, void> {
  handleCloseButtonClick = () => {
    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }
  };

  handleModalClick = event => {
    const { target } = event;

    const header = ReactDOM.findDOMNode(this.refs.header);
    if (header && header.contains(target)) {
      return;
    }

    const image = ReactDOM.findDOMNode(this.refs.image);
    if (image && image.contains(target)) {
      return;
    }

    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }
  };

  render() {
    const { file } = this.props;
    const { url } = file;

    return (
      <Dialog
        {...this.props}
        box={false}
        hideCloseButton
        full
        theme="dark"
        className={cx('ImageFilePreviewModal', this.props.className)}
        onClick={this.handleModalClick}>
        <header ref="header" className="ImageFilePreviewModal-header">
          <MediaObject center figure="right" className="ImageFilePreviewModal-header-inner">
            <TextWithGlyph glyph="image" glyphSize="medium" truncate>
              {file.name}
            </TextWithGlyph>
            <Buttons reset="none">
              <Link
                href={url}
                target="_blank"
                color="white"
                size="small"
                className="ImageFilePreviewModal-viewOriginalButton">
                <TextWithGlyph glyph="fullscreen" glyphSize="small">
                  View original
                </TextWithGlyph>
              </Link>
              <Link href={url} color="white" download size="small">
                <TextWithGlyph glyph="download" glyphSize="small">
                  Download
                </TextWithGlyph>
              </Link>
              <Button
                aria-label="Close"
                color="white"
                level="icon"
                onClick={this.handleCloseButtonClick}>
                <Glyph name="close" solo />
              </Button>
            </Buttons>
          </MediaObject>
        </header>
        <div className="ImageFilePreviewModal-wrap">
          <div className="ImageFilePreviewModal-content">
            <Image ref="image" className="ImageFilePreviewModal-image" src={url} />
          </div>
        </div>
      </Dialog>
    );
  }
}

export default ImageFilePreviewModal;
